import { useMemo, useState } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { cases } from "@/mocks/home";

const statusStyle: Record<string, string> = {
  已核实: "bg-secondary-100 text-secondary-800",
  核验中: "bg-accent-100 text-accent-900",
  待补充: "bg-accent-100 text-accent-900",
  未通过: "bg-background-200 text-foreground-600",
};

export default function Cases() {
  const [active, setActive] = useState("全部");

  const tags = useMemo(() => ["全部", ...Array.from(new Set(cases.map((c) => c.tag)))], []);
  const list = active === "全部" ? cases : cases.filter((c) => c.tag === active);

  return (
    <section id="cases" className="w-full bg-background-50 py-14 md:py-24">
      <div className="w-full px-4 md:px-10">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <SectionHeading
            eyebrow="已核实爆料存档"
            title="不是每一条都能发布，但每一条都有结论"
            desc="下方是进入核验流程的线索处理结果。无论通过还是退回，我们都会标注依据与状态，让核验过程本身也经得起回看。"
          />
          <div className="reveal flex flex-wrap gap-2">
            {tags.map((tag) => (
              <button
                key={tag}
                type="button"
                onClick={() => setActive(tag)}
                className={`px-3.5 py-2 rounded-full text-sm whitespace-nowrap border transition-colors cursor-pointer ${
                  active === tag
                    ? "bg-foreground-950 text-background-50 border-foreground-950"
                    : "bg-background-50 text-foreground-600 border-background-300 hover:border-foreground-400"
                }`}
              >
                {tag}
              </button>
            ))}
          </div>
        </div>

        <div className="mt-10 md:mt-14 flex flex-col gap-4 md:gap-5">
          {list.map((item, index) => (
            <article
              key={item.id}
              className="reveal bg-background-100 border border-background-200 rounded-lg p-5 md:p-7 flex flex-col lg:flex-row lg:items-center gap-5 hover:border-primary-300 transition-colors"
              style={{ animationDelay: `${index * 0.05}s` }}
            >
              <div className="flex-1">
                <div className="flex flex-wrap items-center gap-3 mb-3">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${statusStyle[item.status] ?? "bg-background-200 text-foreground-600"}`}>
                    {item.status}
                  </span>
                  <span className="px-2.5 py-1 rounded-full text-xs bg-background-200 text-foreground-700">{item.tag}</span>
                  <span className="text-xs text-foreground-500">{item.date}</span>
                </div>
                <h3 className="font-heading text-base md:text-lg font-bold text-foreground-950 leading-snug">
                  {item.title}
                </h3>
                <p className="mt-2.5 text-sm leading-relaxed text-foreground-600">{item.summary}</p>
                <p className="mt-3 flex items-center gap-2 text-xs text-foreground-500">
                  <i className="ri-attachment-2"></i>
                  {item.evidence}
                </p>
              </div>
              <a
                href="#submit"
                className="shrink-0 inline-flex items-center justify-center gap-2 px-5 py-2.5 rounded-md border border-primary-300 text-primary-700 text-sm font-medium whitespace-nowrap hover:bg-primary-50 transition-colors cursor-pointer"
              >
                提交同类线索
                <i className="ri-arrow-right-line"></i>
              </a>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}